const namespace = "tournamentStrip";

export const HEADER = `${namespace}.header`;
export const TITLE = `${namespace}.title`;
export const SEE_MORE = `${namespace}.seeMore`;
export const PRIZE_POOL = `${namespace}.prizePool`;
export const BUY_IN = `${namespace}.buyIn`;
export const FREEROLL = `${namespace}.freeroll`;
